<template>
  <v-dialog
    v-model="openedChat"
    :disabled="chatDisable"
    content-class="pl__chat_dialog"
    width="80%"
    @keydown.esc="closeChat"
  >
    <div slot="activator" class="pl-icon-chat pl-flex--padding15">
      <v-badge :color="badgeColor" bottom overlap>
        <span v-if="showNotification && !chatDisable" slot="badge">
          <v-icon color="white">notifications</v-icon>
        </span>

        <span v-if="chatDisable" slot="badge">
          <v-icon color="red">error</v-icon>
        </span>

        <v-icon :disabled="chatDisable" color="black"> chat</v-icon>
      </v-badge>
    </div>

    <v-card>
      <section class="pl-chat">
        <!--    header-->
        <section class="pl-chat__header">
          <div class="pl-chat__header-left">
            <!--            <v-btn-->
            <!--              icon-->
            <!--              @click="toggleAppChatMenu()"-->
            <!--            >-->
            <!--              <v-icon color="rgba(0,0,0,0.6)">-->
            <!--                more_vert-->
            <!--              </v-icon>-->
            <!--            </v-btn>-->

            <h2 class="pl-chat__title">Чат</h2>

            <v-btn v-show="showButtonCreateChat" icon @click="createChat()">
              <v-icon color="rgba(0,0,0,0.6)">
                {{ iconCreateChat }}
              </v-icon>
            </v-btn>
          </div>

          <div class="pl-chat__header-right">
            <div class="pl-chat__header-title">
              <pl-chat-avatar
                v-if="showActiveChatInHeader"
                :entity="activeChat"
                :icon="getAvatarIconType(activeChat.type)"
              />

              <h3 v-if="showActiveChatInHeader" class="pl-chat__header-name">
                {{ getChatName(activeChat) }}
              </h3>

              <v-btn v-show="showButtonSetting" icon @click="openSettingChat()">
                <v-icon color="rgba(0,0,0,0.6)">
                  {{ iconSettingChat }}
                </v-icon>
              </v-btn>
            </div>

            <div
              v-if="
                selectedMessages.length &&
                !forwardReadyMessages.length &&
                !choiceForwardIsActive &&
                (activeChatId || (activeChatId === -1 && idSelectedUser))
              "
              class="pl-chat__chat-actions"
            >
              <v-btn
                v-if="selectedMessages.length > 1"
                class="white--text"
                color="rgb(0, 174, 184)"
                @click="$store.commit('setChatIdForForward', activeChatId)"
              >
                Переслать сюда
              </v-btn>

              <v-btn
                v-else
                class="white--text"
                color="rgb(0, 174, 184)"
                @click="$store.commit('setActiveAnswerItem', selectedMessages[0])"
              >
                Ответить
              </v-btn>

              <v-btn class="white--text" color="rgb(0, 174, 184)" @click="forwardMessages()"> Переслать</v-btn>

              <v-btn icon @click="closeChat()">
                <v-icon color="rgba(0,0,0,0.6)">close</v-icon>
              </v-btn>
            </div>
          </div>
        </section>
        <!--    body-->
        <section class="pl-chat__body">
          <!--  Menu -->
          <pl-chat-setting
            v-if="createSettings && isOpenSetting"
            :activeChatId="activeChatId"
            :open="isOpenSetting"
            @closed-setting="closedSettings"
            @close-setting-not-save="returnPreviousState"
          />

          <images-gallery :images="imagesGallery" @clearImages="$store.commit('setImagesGallery', [])" />

          <div class="pl-chat__aside theme--dark">
            <pl-chat-list
              :activeChatId="activeChatId"
              :chatList="chatList"
              :getChatName="getChatName"
              :idSelectedUser="idSelectedUser"
              :users="usersChatList"
              @loadMoreChats="loadMoreChats($event)"
              @chat-selected="selectChat"
              @user-selected="selectUser"
              @message-selected="selectMessage"
            />
          </div>

          <div class="pl-chat__content">
            <section :class="{ 'pl-chat-search__messages--open': isOpenSearchMessage }" class="pl-chat__message-area">
              <div v-if="choiceForwardIsActive" class="pl-chat__message-empty-area">
                <span>Выберите куда переслать сообщения</span>
              </div>

              <div
                v-else-if="!activeChatId || (activeChatId === -1 && !idSelectedUser)"
                class="pl-chat__message-empty-area"
              >
                <span>Выберите существующий или создайте новый чат</span>
              </div>

              <pl-chat-message-list
                v-if="activeChatId"
                :activeChatId="activeChatId"
                :chatType="activeChatType"
                :idSelectedUser="idSelectedUser"
                :isOpenSearch="isOpenSearchMessage"
                :messages="messages"
                :targetMessageDataFromChatList="selectedMessageAfterSearch"
                @forwardEventFromList="forwardMessages"
              />

              <pl-chat-search-messages />
            </section>

            <pl-chat-input
              :activeChatId="activeChatId"
              :editing="true"
              :idSelectedUser="idSelectedUser"
              @set-id-active-chat="selectChat"
            />
          </div>
        </section>
      </section>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { ImagesGallery } from './ui'
import PlChatMessageList from './PlChatMessageList'
import PlChatList from './PlChatList'
import PlChatInput from './PlChatInput'
import PlChatAvatar from './PlChatAvatar'
import PlChatSetting from './PlChatSetting'
import PlChatSearchMessages from './PlChatSearchMessage'
import PlChatMenu from './PlChatMenu'
import CamelCase from '@/store/plChat/CamelCase'
import { getNameWithLastFourSymbolPhoneNumber } from '@/helpers/nameWithLastFourSymbolPhoneNumber'
import { setReadChatStatus } from '@/api/plChat'
import { EchoChat } from '@/plugins/chat'

const camelCase = new CamelCase()

export default {
  name: 'PlChat',
  components: {
    PlChatSearchMessages,
    PlChatSetting,
    PlChatAvatar,
    PlChatInput,
    PlChatList,
    PlChatMessageList,
    PlChatMenu,
    ImagesGallery,
  },
  data() {
    return {
      chatDisable: true,
      openedChat: false,
      search: '',
      isOpenSetting: false,
      isOpenSearchMessage: false,
      activeChatId: null,
      createSettings: false,
      chatListDataComplete: false,
      idSelectedUser: null,
      showAppChatMenu: false,
      selectedMessageAfterSearch: {},
    }
  },
  async mounted() {
    if (window.EchoChat === null) {
      console.info("I can't connect to chat.")
      return
    }

    await this.connectSocket()

    await this.$store.dispatch('getChatList')

    await this.$store.dispatch('getUsers', {
      reloading: false,
      limit: null,
      offset: null,
    })

    this.chatDisable = false
    this.chatListDataComplete = true
    this.createSettings = true
  },
  computed: {
    ...mapGetters([
      'chatById',
      'newEventChat',
      'chatUser',
      'selectedMessages',
      'choiceForwardIsActive',
      'forwardReadyMessages',
      'imagesGallery',
    ]),
    activeChat() {
      return this.activeChatId ? this.$store.getters.chatById(this.activeChatId) : {}
    },
    activeChatType() {
      return this.activeChat && this.activeChat.type ? this.activeChat.type : ''
    },
    chatName() {
      return this.activeChatId ? this.$store.getters.chatName(this.activeChatId) : ''
    },
    // todo ok
    chatMembers() {
      return this.activeChatId ? this.$store.getters.membersByChatId(this.activeChatId) : []
    },
    chatList() {
      return this.$store.state.plChat.chatList
    },
    usersChatList() {
      if (this.chatListDataComplete) {
        // в списке пользователей показываем только тех, с кем нет приватных чатов
        return this.$store.state.plChat.users.filter(user => {
          return this.chatList.every(
            chat => chat.type !== 'private' || chat?.users?.every(chatUser => chatUser.id !== user.id),
          )
        })
      }
      return []
    },
    messages() {
      return this.activeChat && this.activeChat.messages ? this.activeChat.messages : []
    },
    disableButtonSettingChat() {
      return !!this.idSelectedUser || this.activeChatId === null
    },
    showNotification() {
      return this.$store.getters.newEventChat
    },
    showButtonCreateChat() {
      if (!this.isOpenSetting) {
        return true
      } else {
        return this.activeChatId === -1
      }
    },
    showButtonSetting() {
      return this.activeChat && this.activeChat.type === 'public' && this.activeChat.id !== -1
    },
    iconSettingChat() {
      return this.isOpenSetting ? 'keyboard_arrow_up' : 'settings'
    },
    showActiveChatInHeader() {
      return this.activeChat && this.activeChat.hasOwnProperty('name')
    },
    badgeColor() {
      return this.chatDisable ? 'white' : 'primary'
    },
    iconCreateChat() {
      return this.isOpenSetting ? 'keyboard_arrow_up' : 'post_add'
    },
  },
  methods: {
    isItSocketForCurrentUser(id) {
      return this.chatUser.id === id
    },
    returnPreviousState() {
      this.isOpenSetting = false
      //todo вернуть выбранное в асайде из сохраненного предыдущего состояния.
    },
    closeChat() {
      this.openedChat = false
      this.$store.commit('clearChatDat')
    },
    forwardMessages() {
      this.$store.commit('setChoiceForwardIsActive', true)
      this.activeChatId = null
    },
    getChatName(chatData) {
      if (chatData.type !== 'private') {
        return chatData.name
      } else {
        const memberData = chatData.users.find(user => user.name === chatData.name)

        return getNameWithLastFourSymbolPhoneNumber(memberData)
      }
    },
    async selectMessage(messageData) {
      await this.selectChat(messageData.chatId)
      this.selectedMessageAfterSearch = messageData
    },
    async selectChat(id) {
      this.activeChatId = id

      const chat = this.$store.state.plChat.chatList.find(chat => chat.id === id)
      const chatDataPresent = chat?.messages?.length && chat?.users?.length >= 2

      if (!chatDataPresent) {
        const chatIds = [id]

        await this.$store.dispatch('getMessagesChats', {
          chatIds,
        })
      }

      if (this.choiceForwardIsActive) {
        this.$store.commit('setChatIdForForward', id)
        this.$store.commit('setChoiceForwardIsActive', false)
      }

      this.$store.commit('setActiveChatData', chat)

      this.idSelectedUser = null
    },
    selectUser(id) {
      this.idSelectedUser = id
      this.$store.commit('setNewChat', { chatType: 'private' })
      this.activeChatId = -1

      if (this.choiceForwardIsActive) {
        this.$store.commit('setChatIdForForward', -1)
        this.$store.commit('setChoiceForwardIsActive', false)
      }
    },
    closedSettings(id) {
      this.isOpenSetting = false
      this.selectChat(id)
    },
    toggleAppChatMenu() {
      this.showAppChatMenu = !this.showAppChatMenu
    },
    showSetting() {
      this.isOpenSearchMessage = false
      this.isOpenSetting = !this.isOpenSetting

      if (this.isOpenSetting) {
        this.$store.dispatch('getUsers', {
          reloading: false,
          limit: null,
          offset: null,
        })
      }
    },
    showSearchMessage() {
      this.isOpenSetting = false
      this.isOpenSearchMessage = !this.isOpenSearchMessage
    },
    createChat() {
      this.showAppChatMenu = false

      this.$store.commit('setPrevious', {
        id: this.activeChatId,
        type: null, // todo передавать тип выбранного поля в асайте user || chat
      })
      this.$store.commit('setNewChat', { chatType: 'public' })

      this.activeChatId = -1
      this.showSetting()
    },
    openSettingChat() {
      this.showAppChatMenu = false
      this.isOpenSearchMessage = false
      this.isOpenSetting = !this.isOpenSetting
      //todo если есть активный чат, то вывести его настройки.
      //todo Учесть если чат приватный, то все забизейблено.
    },
    getAvatarIconType(chatType) {
      return chatType === 'public' ? 'people' : 'person'
    },
    async loadMoreChats(chatsPage) {
      await this.$store.dispatch('getChatList', chatsPage)
    },
    connectSocket() {
      window.EchoChat.private(`user.${this.$store.state.plChat.profile.id}`)
        .listen('newMessage', payload => {
          // сокеты newMessage приходят и для отправителя, дублировать сообщение не нужно
          if (!this.isItSocketForCurrentUser(payload.user.id)) {
            const newMessage = camelCase.keysToCamel(payload)
            const chat = camelCase.keysToCamel(payload.chat)
            const message = camelCase.keysToCamel(payload.message)
            const existingChat = this.chatList.find(item => item.id === chat.id)

            if (existingChat && !existingChat.messages) {
              this.$store.dispatch('getMessagesChats', {
                chatIds: [existingChat.id],
              })
            }

            this.$store.commit('SOCKET_newMessage', {
              data: newMessage,
              activeChatId: this.activeChatId,
              openedChat: this.openedChat,
            })

            if (message.isSystem && !this.isItSocketForCurrentUser(message.chat.authorId)) {
              this.$notify({
                group: 'hasBottomNavigation',
                title: `Системное сообщение в "${chat.name}"`,
                type: 'info',
                text: `${message.message}`,
              })
            } else if (chat.type === 'private') {
              this.$notify({
                group: 'hasBottomNavigation',
                title: `Новое сообщение от ${message.user.name}`,
                type: 'info',
                text: `${message.message}`,
              })
            } else if (chat.type === 'public') {
              this.$notify({
                group: 'hasBottomNavigation',
                title: `Новое сообщение в чате "${chat.name}"`,
                type: 'info',
                text: `${message.user.name} <br> ${message.message}`,
              })
            }
          }
        })
        .listen('createChat', payload => {
          const chat = camelCase.keysToCamel(payload)

          if (chat.type === 'private') {
            chat.name = chat.users.find(user => user.id !== this.$store.state.plChat.profile.id).name
          }

          this.$store.commit('setChatList', {
            chatList: [chat, ...this.chatList],
          })
        })
        .listen('editMessage', payload => {
          this.$store.commit('SOCKET_updateMessage', payload)
        })
        .listen('deleteMessage', payload => {
          this.$store.commit('SOCKET_deleteMessage', payload)
        })
        .listen('leaveUser', ({ user, chat }) => {
          // leaveUser для текущего юзера - удаление его из группового чата
          if (this.isItSocketForCurrentUser(user.id)) {
            if (this.activeChatId === chat.id) {
              this.isOpenSetting = false
              this.activeChatId = -1
            }
            if (chat.type === 'public') {
              this.$notify({
                group: 'hasBottomNavigation',
                title: `Вас исключили из чата "${chat.name}"`,
                type: 'info',
              })
            }

            this.$store.commit('removeChat', chat.id)
          }
        })
        .listen('updateChat', payload => {
          this.$store.commit('setChatName', {
            chatId: payload.id,
            value: payload.name,
          })
          this.$store.commit('setChatIcon', {
            chatId: payload.id,
            value: payload.icon,
          })
        })
    },
  },
  watch: {
    isOpenSetting(val) {
      // при закрытии настроек чата мы должны выводить всех пользователей
      if (!val) {
        this.$store.dispatch('getUsers', {
          reloading: false,
          limit: null,
          offset: null,
        })
      }
    },
    openedChat: function (val) {
      if (this.openedChat && this.activeChatId !== null && this.activeChatId !== -1) {
        this.$store.commit('removeNotifyNewMessage', this.activeChatId)

        this.$store.dispatch('getMessagesChats', {
          chatIds: [this.activeChatId],
          nextPage: null,
        })
      }
      if (this.openedChat) {
        this.$store.dispatch('getUsers', {
          reloading: false,
          limit: null,
          offset: null,
        })
      }
    },
    activeChatId: async function () {
      this.$store.commit('removeNotifyNewMessage', this.activeChatId)

      if (this.activeChat.notReadYet) {
        await setReadChatStatus(this.activeChatId)
        this.$store.commit('changeDataInTargetChatItem', {
          ...this.activeChat,
          notReadYet: false,
        })
      }
    },
  },
}
</script>

<style lang="scss">
.pl-chat-search__messages--open {
  & .pl-chat-list {
    flex: 1 0 70%;
  }

  & .pl-chat-search-messages-area {
    flex: 1 0 30%;
  }
}

.pl-chat {
  &__messages {
    &--chat-list-empty {
      margin: 2rem auto auto;
      padding: 0 1rem;
      text-align: center;
    }
  }
}
</style>

<style lang="scss" scoped>
.theme--dark {
  background-color: #424242;
  color: rgba(255, 255, 255, 0.8);
}

.pl-chat {
  color: rgba(0, 0, 0, 0.87);
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: calc(48px + 1rem) calc(85vh - 48px - 1rem);
  height: 85vh;

  &__header {
    align-items: center;
    background-color: white;
    border-bottom: 1px solid rgba(0, 0, 0, 0.4);
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.4);
    display: grid;
    grid-template-columns: 1fr 3fr;
    grid-template-rows: 1fr;
    z-index: 2;
  }

  &__title {
    margin: 1.1rem 0;
  }

  &__header-left {
    align-items: center;
    display: flex;
    justify-content: flex-start;
    padding: 0 2rem;
  }

  &__header-right {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }

  &__header-title {
    align-items: center;
    display: flex;
  }

  &__header-name {
    margin: 0 0 0 1rem;
  }

  &__body {
    display: grid;
    grid-template-columns: 1fr 3fr;
    grid-template-rows: 100%;
  }

  &__aside {
    display: flex;
    flex-direction: column;
    grid-column-end: 2;
    grid-column-start: 1;

    grid-row-end: 2;
    grid-row-start: 1;
    justify-content: space-between;
  }

  &__content {
    display: flex;
    flex-direction: column;
    grid-column-end: 3;
    grid-column-start: 2;

    grid-row-end: 2;
    grid-row-start: 1;
    justify-content: flex-end;
    overflow: hidden;
    position: relative;
  }

  &__message-area {
    display: flex;
    flex: 1 1 auto;
    overflow: hidden;
    position: relative;
    /*height: calc(100% - 56px);*/
  }

  &__message-empty-area {
    align-items: center;
    background-color: rgba(0, 0, 0, 0.16);
    display: flex;
    flex: 1 0 100%;
    justify-content: center;
  }
}
</style>
